import React, { Component } from 'react';
const products = [{
  name: 'CHMER CNC Z-Axis Linear Motor D322CL',
  image: 'https://i.machineryhost.com/4a716f7ba05468f225127f29aa2040c5/8dc869e14c3709a77f7cda77b4af452d/large-chmer-cnc-z-axis-linear-motor-d322-cl.jpg',
  href: '/listings/4738639-chmer-cnc-z-axis-linear-motor-d322cl'
}, {
  name: 'CHMER CNC Z-Axis Linear Motor D433CL',
  image: 'https://i.machineryhost.com/4a716f7ba05468f225127f29aa2040c5/007210a0fa063a3d231673db1e7ac73e/large-0000498_chmer-high-speed-linear-motor-drive-a5030l.jpg',
  href: '/listings/4738640-chmer-cnc-z-axis-linear-motor-d433cl'
}];
export function ChmerZLinearSection() {
  return <section data-id="element-1973">
      <div className="bg-[#1874cd] py-4 px-6 rounded-t-xl" data-id="element-1974">
        <h2 className="text-xl md:text-2xl font-bold text-white" data-id="element-1975">
          Chmer Z Axis Linear Motor CNC EDM
        </h2>
      </div>
      <div className="bg-white p-6 md:p-8 rounded-b-xl shadow-sm border border-gray-200 border-t-0" data-id="element-1976">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-id="element-1977">
          {products.map((product, pIndex) => <div key={pIndex} className="group bg-white rounded-xl shadow-md border border-gray-100 overflow-hidden hover:shadow-xl hover:-translate-y-1 transition-all duration-300 flex flex-col h-full" data-id="element-1978">
              <a href="/m7_view_item.html" className="bg-gray-50 p-6 h-56 flex items-center justify-center border-b border-gray-100 block" data-id="element-1979">
                <img src={product.image} alt={product.name} className="max-w-full max-h-full object-contain group-hover:scale-105 transition-transform duration-500 block" data-id="element-1980" />
              </a>
              <div className="p-5 flex flex-col flex-grow" data-id="element-1981">
                <a href="/m7_view_item.html" className="no-underline" data-id="element-1982">
                  <h3 className="text-base font-bold text-navy mb-4 leading-tight group-hover:text-orange transition-colors" data-id="element-1983">
                    {product.name}
                  </h3>
                </a>
                <div className="mt-auto pt-4 border-t border-gray-100 flex flex-col space-y-2" data-id="element-1984">
                  <a href={`/ContactPeakMachineSales.html?i515589:default[Product%20Title]=${encodeURIComponent(product.name)}`} className="inline-flex items-center justify-center w-full bg-navy text-white px-4 py-2 rounded-md font-bold text-sm hover:bg-orange transition-colors no-underline" data-id="element-1985">
                    Request for Quote
                  </a>
                  <a href="/m7_view_item.html" className="inline-flex items-center justify-center w-full bg-gray-100 text-navy px-4 py-2 rounded-md font-bold text-sm hover:bg-gray-200 transition-colors no-underline" data-id="element-1986">
                    More Information
                  </a>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}